import { render, staticRenderFns } from "./AppRoomsEdit.vue?vue&type=template&id=4fa2974a&scoped=true&"
import script from "./AppRoomsEdit.vue?vue&type=script&lang=js&"
export * from "./AppRoomsEdit.vue?vue&type=script&lang=js&"
import style0 from "./AppRoomsEdit.vue?vue&type=style&index=0&id=4fa2974a&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa2974a",
  null
  
)

export default component.exports